<template>
	<div class="fictitious_box">
		<iframe :src="iframeSrc" class="fictitious_iframe" id="fictitious_iframe" v-if="iframeSrc"></iframe>
	</div>
</template>

<script>
	export default {
		name: 'fictitiousdetail',
		data() {
			return {
				vrDetailId: this.$route.query.vrDetailId,
				type: this.$route.query.type,
				resourceId: this.$route.query.resourceId,
				pid: this.$route.query.pid,
				iframeSrc: "",
			}
		},
		created() {
			this.iframeSrc = './webgl/' + this.type + '.html?vrDetailId=' + this.vrDetailId + '&resourceId=' + this.resourceId + '&pid=' + this.pid;
		},
		mounted() {
			this.$nextTick(() => {
				this.screenFull();
			})
		},
		methods: {
			screenFull() {
				var height = $('.fictitious_box').height();
				var width = $('.fictitious_box').width();
				var w = height / 9 * 16;
				if(w > width) {
					height = width / 16 * 9;
					w = width;
				}
				document.getElementById('fictitious_iframe').style.height = height + 'px';
				document.getElementById('fictitious_iframe').style.width = w + 'px';
				var iframeWindow = (document.getElementById('fictitious_iframe').contentWindow || document.getElementById('fictitious_iframe').contentDocument);
				iframeWindow.addEventListener('myEvent', function(event) {
					window.close();
				})
				$('.fictitious_box').unbind('resize');
			},
		},
	}
</script>